import { useState } from 'react';
import { useAuth } from '../auth';

export function SignInPage() {
  const { enabled, signIn } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSignIn() {
    setBusy(true);
    setError(null);
    try {
      await signIn('/');
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Sign-in failed.');
      setBusy(false);
    }
  }

  return (
    <main className="sign-in card">
      <p className="eyebrow brand"><img src="/brand/packproof-icon.png" alt="" width="28" height="28" />PackProof</p>
      <h1>Sign in</h1>
      <p className="lede">This is the authenticated PackProof Portal. It reads the same PackProof records as the mobile app. Capture stays on your phone.</p>
      {!enabled ? <p className="error">Cognito web configuration is missing. Copy portal/.env.example to portal/.env.local.</p> : null}
      {error ? <p className="error">{error}</p> : null}
      <div className="row">
        <button className="btn" type="button" disabled={busy || !enabled} onClick={() => void onSignIn()}>Sign in with PackProof</button>
      </div>
    </main>
  );
}
